"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default, exports.ASPECT_RATIOS = void 0;
var ASPECT_RATIOS = {
  INSTA: "INSTA",
  SQUARE: "SQUARE",
  STANDARD: "STANDARD",
  WIDE: "WIDE"
};
exports.ASPECT_RATIOS = ASPECT_RATIOS;

function _default() {
  return [{
    label: "INSTAGRAM 9:16",
    value: ASPECT_RATIOS.INSTA,
    prefix: "igtv"
  }, {
    label: "SQUARE 1:1",
    value: ASPECT_RATIOS.SQUARE,
    prefix: "square"
  }, {
    label: "STANDARD 4:3",
    value: ASPECT_RATIOS.STANDARD,
    prefix: "standard"
  }, {
    label: "WIDESCREEN 16:9",
    value: ASPECT_RATIOS.WIDE,
    prefix: "widescreen"
  }];
}